import { render, staticRenderFns } from "./AddPendencyModal.vue?vue&type=template&id=17052794&scoped=true&"
import script from "./AddPendencyModal.vue?vue&type=script&lang=js&"
export * from "./AddPendencyModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPendencyModal.vue?vue&type=style&index=0&id=17052794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17052794",
  null
  
)

export default component.exports